import { render, staticRenderFns } from "./Faculty.vue?vue&type=template&id=bef02726&scoped=true&"
import script from "./Faculty.vue?vue&type=script&lang=js&"
export * from "./Faculty.vue?vue&type=script&lang=js&"
import style0 from "./Faculty.vue?vue&type=style&index=0&id=bef02726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef02726",
  null
  
)

export default component.exports